/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import callAPI from '@/api/callAPI';
import MaskMap from '../MaskMap';
import MultipleMap from '../MultipleMap';

const propTypes = {
  appId: PropTypes.string.isRequired,
  type: PropTypes.string,
  dashId: PropTypes.string.isRequired,
  deveuiState: PropTypes.array.isRequired,
};

const defaultProps = {
  type: 'preview',
};

class DeviceMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      devices: [],
    };
  }

  componentWillMount() {
    this.loadDetail();
  }

  componentWillReceiveProps(nextProps) {
    const { deveuiState } = nextProps;
    if (deveuiState !== this.props.deveuiState) {
      this.loadDevices(deveuiState);
    }
  }

  componentWillUnmount() {
    this.loadDetail = null;
  }

  loadDevices(list) {
    if (list) {
      callAPI({
        endpoint: 'lora/nodeinfos',
        method: 'POST',
        body: { appeui: this.props.appId, list },
      }).then((res) => {
        this.setState({ devices: res.list });
      }).catch(() => {});
    }
  }

  loadDetail() {
    const { dashId } = this.props;
    callAPI({ endpoint: `/lora/dashboards/${dashId}`, method: 'get' })
      .then((res) => {
        const ext = JSON.parse(res.ext);
        this.loadDevices(ext.deveui);
      })
      .catch(() => {});
  }

  render() {
    const { type, dashId } = this.props;
    const { devices } = this.state;
    if (devices.length === 0) {
      return null;
    }
    if (type === 'preview') {
      return <MaskMap devices={devices} dashId={dashId} />;
    }
    return <MultipleMap devices={devices} dashId={dashId} />;
  }
}

DeviceMap.propTypes = propTypes;
DeviceMap.defaultProps = defaultProps;

const mapStateToProps = state => ({
  deveuiState: state.dashboard.getDeveui,
});

export default connect(mapStateToProps, null)(DeviceMap);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/DeviceMap/index.jsx